// Turns a markdown code fence's class (`language-c#`) into the name highlight.js
// should be given. The old pattern, /language-(\w+)/, stopped at the first
// character that is not a word character, so a `c#` or `c++` fence captured
// just `c` and highlight.js used the C grammar for it.
//
// highlight.js 11 already knows both labels as aliases (csharp.js, cpp.js) and
// CodeBlock resolves them through getLanguage, so the pattern is the actual fix.
// The map only gives the block the canonical name.
export const FENCE_LANGUAGE = /language-([\w#+-]+)/;

const CANONICAL = { "c#": "csharp", "c++": "cpp" };

export function fenceLanguage(className) {
  const match = FENCE_LANGUAGE.exec(className || "");
  if (!match) return null;
  return CANONICAL[match[1].toLowerCase()] || match[1];
}
